export const getFromToIndexes = (anchor, count, overall) => ({
  from: anchor * count,
  to: overall && (anchor + 1) * count > overall ? overall - 1 : (anchor + 1) * count - 1,
});
